import { useState } from 'react';
import { useSchedulesQuery } from '../../api/schedules';
import { useStateQuery } from '../../api/state';
import { ScheduleCard } from './ScheduleCard';
import { ScheduleEditor } from './ScheduleEditor';
import type { ScheduleDoc } from '../../domain';

export function SchedulesSection() {
  const q = useSchedulesQuery();
  const state = useStateQuery();
  const deviceId = state.data?.deviceId;
  const [editing, setEditing] = useState<ScheduleDoc | 'new' | null>(null);

  const setback = (q.data ?? []).filter((s) => s.kind === 'setback');
  const solar   = (q.data ?? []).filter((s) => s.kind === 'solar');

  return (
    <>
      {editing === null && (
        <button onClick={() => setEditing('new')} style={{ marginBottom: 'var(--sp-3)' }}>+ New schedule</button>
      )}

      {editing !== null && deviceId && (
        editing === 'new'
          ? <ScheduleEditor
              deviceId={deviceId}
              onSaved={() => { setEditing(null); q.refetch(); }}
              onCancel={() => setEditing(null)}
            />
          : <ScheduleEditor
              deviceId={deviceId}
              initial={editing}
              onSaved={() => { setEditing(null); q.refetch(); }}
              onCancel={() => setEditing(null)}
            />
      )}

      <h2>Setback schedules</h2>
      {q.isLoading && <div className="skeleton" style={{ height: 100 }} />}
      {setback.length === 0 && !q.isLoading && <div className="muted">No setback schedules.</div>}
      {setback.map((s) => <ScheduleCard key={s.id} doc={s} onEdit={(d) => setEditing(d)} />)}

      <h2>Solar schedules</h2>
      {solar.length === 0 && !q.isLoading && <div className="muted">No solar schedules.</div>}
      {solar.map((s) => <ScheduleCard key={s.id} doc={s} onEdit={(d) => setEditing(d)} />)}

      {q.isError && <div className="banner danger">{(q.error as Error).message}</div>}
    </>
  );
}
